module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_WSD.e4cced40.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_WSD.png
// module id = 71
// module chunks = 0